<template>
  <div id="placeList">
    <div v-for="sort in sorts" :key="sort.type">
      <template v-if="places(sort.type).length > 0">
        <h2 class="section-title m-4 text-center text-lg" v-html="sort.label"></h2>
        <div>
          <ul class="courselist pl-4">
            <li v-for="place in places(sort.type).slice(0, sort.maxPlace)" :key="place.id">
              <div class="course">
                <div class="course-info">
                  <div class="float-right pt-2 pr-1">
                    <div v-if="token !== null">
                      <favorite :place="place" />
                    </div>
                    <div v-else>
                      <button @click="$emit('registration', place)" class="border border-gray-400 focus:outline-none rounded h-8 w-8 p-1 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                          <path d="M11 4.22l-.61-.6c-2.1626-2.045-5.5596-1.9987-7.6656.1046C.6184 5.8278.5677 9.2248 2.61 11.39L11 19.78l8.39-8.4c2.0423-2.1652 1.9916-5.5622-.1144-7.6654-2.106-2.1033-5.503-2.1497-7.6656-.1046l-.61.61z" stroke="#979797" stroke-width="1" fill="none" fill-rule="evenodd"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <h3 class="course-title">
                    {{ place.name }}
                  </h3>
                  <img v-lazy="place.image" class="course-image" />
                  <p class="course-detail" v-html="place.detail"></p>
                </div>
                <div class="course-button m-4">
                  <a class="button-primary block" @click="showModal(place)">
                    {{ $t('display_detail_label') }}
                  </a>
                </div>
              </div>
            </li>
            <li v-if="places(sort.type).length > sort.maxPlace">
              <div class="course">
                <div class="course-info">
                  <h3 class="course-title text-white">*</h3>
                  <div class="text-center text-gray-500 px-5">
                    <a @click="addPlace(sort)">スポットをさらに表示する場合はこちらをタップしてください</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>

    <PoiModal v-show="modal.show" :closeModal="() => closeModal()">
      <PoiDetail v-show="modal.show" :place="place"  @createItem="createItem" />
    </PoiModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PoiModal from "../molecules/PoiModal"
import PoiDetail from '../molecules/PoiDetail'
import Favorite from '../molecules/Favorite'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  name: 'PoiList',
  components: {
    PoiModal,
    PoiDetail,
    Favorite
  },
  data () {
    return {
      place: {},
      modal: {
        show: false
      },
      sorts: [
        {
          label: "お気に入りスポットから<br />My旅行プランをつくる",
          type: "favorites",
          maxPlace: 1000
        },
        {
          label: "おすすめスポットから<br />My旅行プランをつくる（人気エリア順表示）",
          type: "area",
          maxPlace: 1000
        },
        {
          label: "おすすめスポットから<br />My旅行プランをつくる（カテゴリ順表示）",
          type: "category",
          maxPlace: 1000
        }
      ]
    }
  },
  methods: {
    showModal (place) {
      this.place = place
      this.modal.show = true
    },
    closeModal () {
      this.modal.show = false
    },
    createItem (poiId) {
      // GoogleAnalytics
      this.$gtag.event("POIからプラン作成", {
        poi_name: this.place.name,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.token
      });
      if (this.$store.getters['user/getToken'] !== null) {
        if (this.$store.getters['user/getProfile'] !== null) {
          this.$router.push({ name: 'newPlan', params: { poiId: poiId } })
        } else {
          this.$emit('openPlanSetting')
        }
      } else {
        this.$emit('openPlanTerms')
      }
    },
    places (type) {
      var poi = []
      const places = this.$store.getters['places/getPlaces']
      if (type === "area") {
        const area = ["waikiki", "kahala", "alamoana", "manoa", "kakaako", "aiea", "koolina", "northshore", "kailua"]
        for (let i = 0; i < area.length; i++) {
          places.forEach(place => {
            if (place.area !== undefined && place.area === area[i] && place.planTop) {
              poi.push(place)
            }
          })
        }
      } else if (type === "category") {
        const categories = ["Wellness", "Art/Tourism", "Activity", "Shopping", "Gourmet"]
        for (let i = 0; i < categories.length; i++) {
          places.forEach(place => {
            if (place.genreIds.includes(categories[i]) && place.planTop) {
              poi.push(place)
            }
          })
        }
      } else if (type === "favorites") {
        for (let i = this.favorites.length -1; i >= 0 ; i--) {
          poi.push(this.favorites[i])
        }
      }
      return poi
    },
    addPlace (sort) {
      sort.maxPlace += 5
    }
  },
  computed: {
    ...mapGetters({
      favorites: 'favorites/getFavoritedPlaces',
      token: 'user/getToken'
    })
  }
}
</script>
